/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import makeFormReadOnly from '@/util/makeFormReadOnly';
import EmptySetView from '@/views/EmptySetView';

import OrderAccess from '../../utils/OrderAccess';
import RelocationPrintView from '../../forms/PrintFormView/RelocationPrintView/RelocationPrintView';
import LoadOrderGeneral from '../../loaders/OrderGeneralLoader';



import tmplOrderPrintView from './OrderPrintView.hbs';

const OrderPrintView = View.extend({
  template: tmplOrderPrintView,

  className: 'order-print-view',

  ui: {
    printView: '.print-view',
    errorView: '.error-view'
  },

  regions: {
    printView: '@ui.printView',
    errorView: '@ui.errorView'
  },

  onRender() {
    const isCRSOwner = this.options.isCRSOwner;
    const statusId = this.options.statusId;
    const orderDetails = this.model.get('orderDetails');
    const orderId = this.model.get('orderId');
    const commandPOCs = this.model.get('commandPOCs');
    const orderTypeId = orderDetails.orderFormTypeId;

    const isEditable = OrderAccess.isEditable(statusId, isCRSOwner, this.isEditing);


    const orderData = { orderId, orderTypeId, isReadOnly: !isEditable, orderDetails, commandPOCs };

    const generalView = LoadOrderGeneral({ ...orderData, editable: isEditable })

    switch (this.model.get('orderDetails').orderFormTypeId || this.model.get('orderPackage').orderFormTypeID) {
      case '13':
        this.showChildView(
          'printView',
          generalView
        );
        break;

      case '12':
        this.showChildView(
          'printView',
          new RelocationPrintView({
            model: new Backbone.Model({
              allLineItems: this.model.get('allLineItems'),
              orderDetails: this.model.get('orderDetails'),
              extOrderDetails: this.model.get('extOrderDetails'),
              internalPOCs: this.model.get('internalPOCs'),
              order: this.model.get('order'),
              deliverySchedules: this.model.get('deliverySchedules')
            })
          })
        );
        break;

      default:
        this.showChildView(
          'errorView',
          new EmptySetView({
            emptyText: 'This order type does not have a printer friendly version.'
          })
        );
        break;
    }

    makeFormReadOnly(this.$el);
  }
});

export default OrderPrintView;
